<div class="flex flex-col max-w-[95vw] max-h-[90vh] md:min-w-140 -m-6" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" cdkDragHandle>
        <div class="text-lg font-medium">Change password</div>
        <button mat-icon-button type="button" aria-label="Close dialog" (click)="close()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <form class="flex flex-col gap-6 p-6 sm:p-8 overflow-y-auto change-password-form" [formGroup]="form" (ngSubmit)="confirm()">
        <mat-form-field appearance="outline" class="w-full">
            <mat-label>Current password</mat-label>
            <input matInput autocomplete="current-password" [type]="hideOldPassword ? 'password' : 'text'" formControlName="oldPassword" />
            <button mat-icon-button matSuffix type="button" aria-label="Show or hide current password" (click)="hideOldPassword = !hideOldPassword">
                <mat-icon [svgIcon]="hideOldPassword ? 'heroicons_outline:eye' : 'heroicons_outline:eye-slash'"></mat-icon>
            </button>
            @if (form.controls.oldPassword.touched && form.controls.oldPassword.hasError('required')) {
                <mat-error>Current password is required</mat-error>
            }
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-full">
            <mat-label>New password</mat-label>
            <input matInput autocomplete="new-password" [type]="hideNewPassword ? 'password' : 'text'" formControlName="newPassword" />
            <button mat-icon-button matSuffix type="button" aria-label="Show or hide new password" (click)="hideNewPassword = !hideNewPassword">
                <mat-icon [svgIcon]="hideNewPassword ? 'heroicons_outline:eye' : 'heroicons_outline:eye-slash'"></mat-icon>
            </button>
            @if (form.controls.newPassword.touched && form.controls.newPassword.hasError('required')) {
                <mat-error>New password is required</mat-error>
            }
            @if (form.controls.newPassword.touched && !form.controls.newPassword.hasError('required') && missingPasswordCriteria.length > 0) {
                <mat-error>Password does not meet all the requirements below</mat-error>
            }
        </mat-form-field>

        <div class="password-strength" [ngClass]="strength.colorClass">
            <div class="strength-header">
                <span>Password strength</span>
                <span>{{ strength.label }}</span>
            </div>
            <div class="strength-meter">
                <div class="strength-meter-fill" [style.width.%]="(strength.score / 5) * 100"></div>
            </div>
            @if (form.controls.newPassword.value) {
                <div class="password-criteria" aria-label="Password requirements">
                    @for (criterion of passwordCriteria; track criterion.label) {
                        <span [class.criterion-met]="criterion.met">
                            <span class="criterion-dot"></span>
                            {{ criterion.label }}
                        </span>
                    }
                </div>
            }
        </div>

        <mat-form-field appearance="outline" class="w-full" [class.ng-invalid]="passwordsDoNotMatch">
            <mat-label>Confirm new password</mat-label>
            <input matInput autocomplete="new-password" [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirmNewPassword" />
            <button mat-icon-button matSuffix type="button" aria-label="Show or hide password confirmation" (click)="hideConfirmPassword = !hideConfirmPassword">
                <mat-icon [svgIcon]="hideConfirmPassword ? 'heroicons_outline:eye' : 'heroicons_outline:eye-slash'"></mat-icon>
            </button>
            @if (form.controls.confirmNewPassword.touched && form.controls.confirmNewPassword.hasError('required')) {
                <mat-error>Password confirmation is required</mat-error>
            }
            @if (form.controls.confirmNewPassword.touched && form.controls.confirmNewPassword.hasError('passwordMismatch')) {
                <mat-error>Passwords do not match</mat-error>
            }
        </mat-form-field>

        @if (isTermsAcceptanceRequired) {
            <section class="terms-and-conditions">
                <div class="flex items-center justify-between gap-4">
                    <div>
                        <div class="font-medium">Terms and conditions</div>
                        <div class="text-sm text-secondary">Open and read the document before accepting.</div>
                    </div>
                    <a
                        mat-flat-button
                        color="primary"
                        class="document-button"
                        [class.document-button-opened]="termsOpened"
                        [href]="termsDocumentUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        (click)="markTermsAsOpened()"
                        aria-live="polite">
                        <mat-icon [svgIcon]="termsOpened ? 'heroicons_outline:check-circle' : 'heroicons_outline:arrow-top-right-on-square'"></mat-icon>
                        {{ termsOpened ? 'Opened · Open again' : 'Open document' }}
                    </a>
                </div>

                <mat-checkbox formControlName="termsAccepted">
                    I have read and accept the Terms of Use and Privacy Policy
                </mat-checkbox>

                @if (!termsOpened || !form.controls.termsAccepted.value) {
                    <mat-error class="terms-error">
                        To continue, open the document and accept the terms and conditions.
                    </mat-error>
                }
            </section>
        }
    </form>

    <div class="flex items-center justify-end gap-4 py-4 px-6">
        <button mat-button type="button" color="primary" (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" type="button" (click)="confirm()" [disabled]="!canConfirm">
            Confirm
        </button>
    </div>
</div>
